import React from 'react';
import {injectIntl} from "react-intl";
import DaysConfiguration from "./DaysConfiguration";
import {EXCHANGE_TIRES, EXCHANGE_WHEELS} from "../WheelsExchangeUtils";

class ExchangeConfiguration extends React.Component {

  render() {
    const {intl: {formatMessage}} = this.props;

    return (
      <div>
        <header className="main-header">
          <div className="main-header__left">
            <h1 className="main__title">
              {formatMessage({id:'page.exchange-configuration'})}
            </h1>
          </div>
        </header>

        <div className="main__content">
          <div className="section">
            <DaysConfiguration type={EXCHANGE_WHEELS} />
          </div>
          <div className="section">
            <DaysConfiguration type={EXCHANGE_TIRES} />
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(ExchangeConfiguration);
